import { gql, useMutation } from '@apollo/client'
import Button from '@mui/material/Button'

import { BRAND_PASSWORD_REQUIRED_LENGTH } from 'pared/constants/brands'
import { getBrand } from 'pared/utils/brand'

const MUTATION_CHANGE_PASSWORD = gql`
  mutation ChangePassword($userId: Int!, $newPassword: String!) {
    updatePasswordByExpoAdmin(
      input: { iUserId: $userId, iNewPassword: $newPassword }
    ) {
      boolean
    }
  }
`

const ChangePasswordButton = ({ userId }: { userId: number }) => {
  const [changePassword, { loading }] = useMutation(MUTATION_CHANGE_PASSWORD)

  const onChangePassword = async () => {
    const inputtedNewPassword = prompt('Enter new password:')
    if (inputtedNewPassword === null) {
      return
    }

    const brand = getBrand()
    const passwordRequiredLength = BRAND_PASSWORD_REQUIRED_LENGTH[brand] || 8
    const trimmedNewPassword = inputtedNewPassword.trim()
    if (trimmedNewPassword.length < passwordRequiredLength) {
      alert(
        `Invalid password. The length of the password must be at least ${passwordRequiredLength}.`,
      )

      return
    }

    if (trimmedNewPassword.length !== inputtedNewPassword.length) {
      alert('Invalid password. White spaces are not allowed.')
      return
    }

    await changePassword({
      variables: {
        userId,
        newPassword: trimmedNewPassword,
      },
    })
  }

  const handleClick = async () => {
    await onChangePassword()
  }

  return (
    <Button disabled={loading} onClick={handleClick}>
      Change Password
    </Button>
  )
}

export default ChangePasswordButton
